/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'react',
	'prop-types',
	'@ba/ba-ui-carbon',
	'@ba/ba-ui-carbon-toolkit',
	'./TemplateLayout',
	'../../lib/@waca/core-client/js/core-client/ui/KeyCodes'
], function(React, PropTypes, Carbon, Carbon_toolkit, TemplateLayout, KeyCodes) {
	const { Component } = React;
	const { TileGroup, RadioTile } = Carbon;
	const { Container, SVGIcon } = Carbon_toolkit;

	class LayoutPicker extends Component {
		constructor(props) {
			super(props);
		}

		render () {
			if(this.props.templates && this.props.templates.length) {
				const contentItems = this.props.templates.map((templateLayout, index) => this._getTemplateTile(templateLayout, index));
				return (
					<TileGroup
						className='layoutPickerContainer'
						valueSelected={this.props.defaultTemplateSelected}
						onChange={(...params) => this.props.onSelectedTemplateId(...params)}
						ref={node => this.tileGroupRef = node}
					>
						{contentItems}
					</TileGroup>
				);
			}
			return null;
		}

		_getTemplateTile (templateLayout, index) {
			const { layoutSpec, templateId, ariaLabel, icon } = templateLayout;
			let classes = 'layoutTemplateItem';
			classes = this.props.selectedNavModel ? `${classes} ${this.props.selectedNavModel}` : classes;
			return (
				<RadioTile
					className={classes}
					id={templateId}
					value={templateId}
					onKeyDown={(event) => this._onKeyDown(event)}
					tabIndex={0}
					aria-label={ariaLabel}
					aria-posinset={index + 1}
					aria-setsize={this.props.templates.length}
					data-id={templateId}
					light={this.props.light}
				>
					{ icon ?
						(<Container
							onDoubleClick={() => this.props.action()}
						>
							<SVGIcon
								size='xxlarge'
								iconId={icon}
							/>
						</Container>)
						:
						(<TemplateLayout
							layoutSpec={layoutSpec}
							action={this.props.action}
							showContextMenu={this.props.showContextMenu}
						>
						</TemplateLayout>)
					}
				</RadioTile>
			);
		}

		_onKeyDown (event) {
			switch (event.keyCode) {
				case KeyCodes.ENTER:
				case KeyCodes.SPACE:
					event.stopPropagation();
					this.props.action();
					break;
			}
		}
	}

	LayoutPicker.propTypes = {
		action: PropTypes.func.isRequired,
		onSelectedTemplateId: PropTypes.func.isRequired,
		templates: PropTypes.array.isRequired,
		defaultTemplateSelected: PropTypes.string,
		showContextMenu: PropTypes.func,
		selectedNavModel: PropTypes.string,
		light: PropTypes.bool
	};

	return LayoutPicker;
});
